(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('VaccineSearch', VaccineSearch);

    VaccineSearch.$inject = ['$resource'];

    function VaccineSearch($resource) {
        var resourceUrl =  'api/_search/vaccines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
